import { format } from "date-fns";
import { signal } from "@preact/signals-react";

import { cn } from "tools/ui";

const rowCount = signal(1);
const styleHead = "text-2xl text-center mt-8 mb-2 mx-auto text-neutral-700";

const activities = [
  {
    id: 1,
    type: "check_in",
    description:
      "Se hace Check-In en la habitación 407, huesped -> Mateo Smith",
    dateTime: new Date(),
  },
  {
    id: 2,
    type: "check_out",
    description:
      "Se hace Check-Out en la habitación 308, huesped -> Cristina Falker",
    dateTime: new Date(),
  },
  {
    id: 3,
    type: "check_in",
    description: "Se hace Check-In en la habitación 408, huesped -> Ana Garcia",
    dateTime: new Date(),
  },
  {
    id: 4,
    type: "check_out",
    description:
      "Se hace Check-Out en la habitación 408, huesped -> Ana Garcia",
    dateTime: new Date(),
  },
];

function getRow(activity) {
  rowCount.value += 1;
  return (
    <button
      key={activity.id}
      type="button"
      className={cn(
        "flex px-4 py-4 hover:bg-blue-100 cursor-pointer",
        rowCount.value % 2 === 0 ? "bg-stone-100" : "bg-white",
      )}
      onClick={() => onClick(activity)}
    >
      <span className="text-teal-600">
        {format(activity.dateTime, "HH:mm aaa")}
      </span>
      <span className="ml-3 text-neutral-700">{activity.description}</span>
    </button>
  );
}

function onClick(activity) {
  console.log("Activity item clicked...", activity.id);
}

function DeskActivity(disabled) {
  if (disabled) {
    return (
      <div className={styleHead}>
        Last <span className="font-bold">Activities</span>
      </div>
    );
  }
  return (
    <div>
      <h2 className={styleHead}>
        Last <span className="font-bold">Activities</span>
      </h2>
      <div className="mt-2 text-sm">
        {activities.map((activity, index) => getRow(activity, index))}
      </div>
    </div>
  );
}

export default DeskActivity;
